import { createFeatureSelector } from '@ngrx/store';
import { OrmState } from './index';

export const selectOrm = createFeatureSelector<OrmState>('orm');
